import React from 'react';
import { AllocationGroup } from '../AllocationGroup';
import { AllocationRow } from '../AllocationRow';
import { ApButtonSecondary } from '@alixpartners/ui-components';
import { IAllocationListItem, IAllocation } from '../types';
import { GridRow } from '../AllocationGroup/AllocationGroup.styles';
import { ListWrapper } from '../styles';
import {
  HeaderLabel,
  HeaderRightLabel,
  HeaderCenterLabel,
  Wrapper,
  ActionsWrapper,
  SearchWrapper,
  NoDataWrapper,
  StyledSearch,
} from './AllocationList.styles';
import groupBy from 'lodash/groupBy';
import isEmpty from 'lodash/isEmpty';

const GROUP_PROP = 'groupName';

interface IProps {
  items: IAllocationListItem[];
  allocations?: IAllocation[];
  onChange(items: IAllocation[]): void;
  title?: string;
  flagTitle?: string;
}

interface IState {
  search?: string;
  isExpandAll: boolean;
}

export class AllocationList extends React.Component<IProps, IState> {
  state = { isExpandAll: true, search: '' };

  getItemsWithAllocations = () => {
    const { allocations, items } = this.props;

    if (!allocations) {
      return items;
    }

    return items.map((item) => {
      const itemAllocation = allocations.find(
        (allocation) => allocation.id === item.id
      );

      if (itemAllocation) {
        return { ...item, percentage: itemAllocation.percentage };
      }

      return { ...item };
    });
  };

  expandAllGroups = () => {
    this.setState({ isExpandAll: false }, () => {
      this.setState({ isExpandAll: true });
    });
  };

  onSearchChange = (search: any) => {
    this.setState({ search });
    this.expandAllGroups();
  };

  onSearchClear = () => {
    this.setState({ search: '' });
    this.expandAllGroups();
  };

  getGroupedData = () => {
    return groupBy(this.getFilteredItems(), GROUP_PROP);
  };

  getFilteredItems = () => {
    const { search } = this.state;

    return search
      ? this.getItemsWithAllocations().filter((item) =>
          item.name.toLowerCase().includes(search.toLowerCase())
        )
      : this.getItemsWithAllocations();
  };

  handleItemChange = (allocationItem: IAllocation) => {
    const { onChange, allocations } = this.props;
    const allocationItems = allocations || [];
    const currentAppIndex = allocationItems.findIndex(
      (item) => item.id === allocationItem.id
    );

    let updatedItems = [];

    if (allocationItem.percentage) {
      if (currentAppIndex !== -1) {
        updatedItems = [
          ...allocationItems.filter((item, index) => {
            return index !== currentAppIndex;
          }),
          allocationItem,
        ];
      } else {
        updatedItems = [...allocationItems, allocationItem];
      }
    } else {
      updatedItems = allocationItems.filter((item, index) => {
        return index !== currentAppIndex;
      });
    }

    onChange(updatedItems);
  };

  clearAllocation = () => {
    const { onChange } = this.props;

    onChange([]);
  };

  isInvalid = () =>
    this.getItemsWithAllocations().reduce(
      (acc, item) => acc + (item.percentage || 0),
      0
    ) > 100;

  render() {
    const { allocations, items, title, flagTitle } = this.props;
    const { isExpandAll, search } = this.state;
    const groupedItems = this.getGroupedData();
    const isGrouped = !!items[0] && !!items[0].groupName;
    const showFlag = !!items[0] && items[0].flag !== undefined;

    return (
      <Wrapper>
        <ActionsWrapper>
          <SearchWrapper>
            <StyledSearch
              id="allocation-search"
              onChange={this.onSearchChange}
              onClear={this.onSearchClear}
            />
          </SearchWrapper>
          <ApButtonSecondary
            disabled={!allocations}
            onClick={this.clearAllocation}
          >
            Clear allocation
          </ApButtonSecondary>
        </ActionsWrapper>

        <GridRow>
          <HeaderLabel>{title ? title : 'Application name'}</HeaderLabel>
          <HeaderRightLabel>Allocation</HeaderRightLabel>
          {showFlag && (
            <HeaderCenterLabel>
              {flagTitle ? flagTitle : 'Corporate app'}
            </HeaderCenterLabel>
          )}
        </GridRow>
        {isGrouped ? (
          !isEmpty(groupedItems) ? (
            <ListWrapper>
              {Object.keys(groupedItems).map((name) => (
                <AllocationGroup
                  key={name}
                  name={name}
                  data={groupedItems[name]}
                  isExpandedProp={isExpandAll}
                  onChange={this.handleItemChange}
                  isInvalid={this.isInvalid()}
                  search={search}
                />
              ))}
            </ListWrapper>
          ) : (
            <NoDataWrapper>No results found</NoDataWrapper>
          )
        ) : (
          <ListWrapper>
            {this.getFilteredItems().length > 0 ? (
              this.getFilteredItems().map((item) => (
                <AllocationRow
                  key={item.id}
                  data={item}
                  isInvalid={this.isInvalid()}
                  search={search}
                  onChange={this.handleItemChange}
                />
              ))
            ) : (
              <NoDataWrapper>No results found</NoDataWrapper>
            )}
          </ListWrapper>
        )}
      </Wrapper>
    );
  }
}
